import React from 'react';
import Image from '../../../../Shared/Image/image';
import PackageDetails from '../PackageDetails/PackageDetails';
import './internetOrderSuccess.scss';

const TECHNICIAN_TIP = 'חשוב שיהיה בבית מישהו מעל גיל 18 כדי לקבל את הטכנאי';

const DetailRow = ({ label, value }) => (
  <div className='internet-order-success__row'>
    <span className='internet-order-success__row-label'>{label}</span>{' '}
    <span className='internet-order-success__row-value'>{value}</span>
  </div>
);

const InternetOrderSuccess = ({ summaryDetails }) => {
  const supplyType = summaryDetails?.supplyType;
  const isTechnician = supplyType === 'technician';
  const isDelivery = supplyType === 'delivery';

  const address = summaryDetails?.selectedAddress;
  const addressText = [
    [address?.streetName, address?.home].filter(Boolean).join(' '),
    address?.cityName,
  ]
    .filter(Boolean)
    .join(', ');

  const personalInfo = summaryDetails?.personalInfo;
  const contactText = [
    [personalInfo?.firstName, personalInfo?.lastName].filter(Boolean).join(' '),
    personalInfo?.subscriberNo,
  ]
    .filter(Boolean)
    .join(', ');

  const arrivalTime = isTechnician
    ? summaryDetails?.selectedTechnicianTimeDisplay
    : summaryDetails?.selectedDeliveryTimeDisplay;
  const arrivalLabel = isTechnician ? 'הגעת טכנאי:' : 'מתי השליח יגיע:';
  const cardTitle = isTechnician ? 'פרטי התקנה' : 'פרטי משלוח';
  const hasSupplyCard = (isTechnician || isDelivery) && (arrivalTime || addressText || contactText);

  return (
    <div className='internet-order-success'>
      {hasSupplyCard && (
        <div className='internet-order-success__card'>
          <h2 className='internet-order-success__card-title'>{cardTitle}</h2>
          <div className='internet-order-success__card-body'>
            {arrivalTime && <DetailRow label={arrivalLabel} value={arrivalTime} />}
            {addressText && <DetailRow label='כתובת:' value={addressText} />}
            {contactText && <DetailRow label='פרטי יצירת קשר:' value={contactText} />}
            {isTechnician && (
              <div className='internet-order-success__tip'>
                <Image
                  src={require('../Summary/images/icon-light.svg')}
                  className='internet-order-success__tip-icon'
                  alt=''
                />
                <span className='internet-order-success__tip-text'>{TECHNICIAN_TIP}</span>
              </div>
            )}
          </div>
        </div>
      )}

      <div className='internet-order-success__package'>
        <PackageDetails />
      </div>
    </div>
  );
};

export default InternetOrderSuccess;
